import { Fragment } from 'react';
import type { ReactNode } from 'react';

type FieldRow = [ReactNode, ReactNode];

interface FieldGridProps {
  rows: FieldRow[];
}

export function FieldGrid({ rows }: FieldGridProps) {
  return (
    <div className="mp-fields-wrap">
    <table className="mp-fields">
      <tbody>
        {rows.reduce<FieldRow[][]>((acc, _, i) => {
          if (i % 2 === 0) acc.push(rows.slice(i, i + 2));
          return acc;
        }, []).map((pair, i) => (
          <tr key={i}>
            {pair.map(([l, v], j) => (
              <Fragment key={j}>
                <th>{l}</th>
                <td>{v}</td>
              </Fragment>
            ))}
            {pair.length === 1 ? <Fragment><th></th><td></td></Fragment> : null}
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  );
}
